import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ITableColumn, ITableConfig, ITableItem, SuperButton } from '@devinforius/super-compos-17';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IScanServices } from 'src/app/core/services/iscan.service';
import { UploadScan } from 'src/app/shared/models/iScanV1/upload-scan';
import {
  getButtonTitle,
  getColumnsDocumentLink,
  getColumnsScan,
  getMenuCase1,
  getMenuCase2,
  getTabsScan,
} from './columns-config';
import { SuperTabsXl } from 'src/app/shared/models/super-tabs-xl';
import { SessionStorage } from 'src/app/shared/models/session-storage';
import { ScanService } from 'src/app/core/services/scan.service';
import { ScanFromDelibe, ScanFromDelibePaginate, splitScan } from 'src/app/shared/models/iScanV1/scan-from-delibe';
import { ITableCategoryAction } from '@devinforius/super-compos-17/lib/i-table/models/i-table-category-action.model';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { AddScanIDelibe } from 'src/app/shared/models/iScanV1/add-scan-idelibe';
import { DialogService } from 'primeng/dynamicdialog';
import { IModalParams } from '@devinforius/super-compos-17/lib/i-modal/models/i-modal-parameters.model';
import { IModalHeader } from '@devinforius/super-compos-17/lib/i-modal/models/i-modal-header.model';
import { saveAs } from 'file-saver';
import { SignalrService } from 'src/app/core/services/signalr.service';
import { NotifyUserSignalrPayload, SignalrPayloadEventId } from 'src/app/shared/models/signalr_payloads';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@devinforius/super-compos-17';
import { addDays } from 'date-fns';
import { IContactService } from 'src/app/core/services/i-contact.service';
import { UserContact } from 'src/app/shared/models/iContact/user-contact';
import { MeRight } from 'src/app/shared/models/right';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';

@Component({
  selector: 'app-home-scan',
  templateUrl: './home-scan.component.html',
  styleUrls: ['./home-scan.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeScanComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  tableConfigurations: ITableConfig;
  tableConfigurationsLinkScan: ITableConfig;
  itemsDocumentLink: ITableItem[] = [];
  items: ScanFromDelibe[] = [];
  tabsArrayXLActiveIndex: number = 0;
  buttons: Array<SuperButton & { loading: boolean }>;
  menu: ITableCategoryAction[] = [];
  notifyUserSubscription: Subscription;
  columns: ITableColumn[];
  columnsDocumentLink: ITableColumn[];
  tabs: SuperTabsXl[];
  openDialogDocumentLink: boolean = false;
  modalParams: IModalParams;
  modalHeader: IModalHeader;
  totalRecords: number;
  rows: number = 10;
  first: number = 0;
  pageNumber: number = 1;
  isGestionnaire: boolean = false;
  uniqueUserIds: number[] = [];

  constructor(
    public router: Router,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private iscanServices: IScanServices,
    private ScanService: ScanService,
    public dialogService: DialogService,
    public signalRService: SignalrService,
    private confirmationService: ConfirmationService,
    private translater: TranslateService,
    private iContactService: IContactService,
    private IDelibeMeService: IDelibeMeService
  ) {}

  ngOnInit(): void {
    this.notifyUserSubscription = this.signalRService.notifyUser.subscribe((payload: NotifyUserSignalrPayload) => {
      if (payload.payloadEventId == SignalrPayloadEventId.IScanLotStatusChanged) {
        this.getItems('toTreat', 1);
      }
    });
    this.buttons = getButtonTitle(this, this.translater);
    this.columnsDocumentLink = getColumnsDocumentLink();
    this.tabs = getTabsScan();
    this.setConfigurationTable();
    this.setConfigurationTableLinkScan();
    this.getItems('toTreat', 1);
    this.setMenuAction();
    this.setModalConfiguration();
    this.callChainedGetContact();
  }

  callChainedGetContact(): void {
    this.IDelibeMeService.getUserRights().subscribe({
      next: (rights: MeRight) => {
        this.isGestionnaire = rights.globalDelibeRight.IsAdminIScan;
        this.getContact().subscribe({
          next: (contacts: UserContact[]) => {
            const initColumn = getColumnsScan();
            if (this.isGestionnaire) {
              initColumn.push({
                field: 'userId',
                header: 'Contact',
                width: '25%',
                format: (value) => {
                  if (value) {
                    const user = contacts.find((contact) => contact.userId === value);
                    return user ? `${user.name}` : '-';
                  } else {
                    return '-';
                  }
                },
              });
            }
            this.columns = initColumn;
          },
          error: () => {
            return false;
          },
        });
      },
      error: () => {
        return false;
      },
    });
  }

  getContact(): Observable<UserContact[]> {
    const data = {
      UserIds: this.uniqueUserIds.toString(),
    };
    return this.iContactService.getUserWithDataAdmin(data);
  }

  getGlobalConfig(): SessionStorage {
    const globalConfig = sessionStorage.getItem('globalConfig');
    if (globalConfig) {
      return JSON.parse(globalConfig);
    }
  }

  setConfigurationTable(): void {
    this.tableConfigurations = new ITableConfig({
      showPaginator: true,
      showColumnSelector: false,
      showForSelectionRow: false,
      isRowClickable: true,
      multiselect: false,
      viewSearch: false,
      resizableColumns: true,
      reorderableColumns: true,
      rowPerPageOptions: [10, 20, 50, 100, 500],
      pageSize: this.rows,
      pageFirst: this.first,
      lazy: true,
      totalRecords: this.totalRecords,
      baseSortColumn: { field: 'lastTransition.statutId', currentSort: -1 },
      height: '80vh',
      tableStyle: { width: '100%' },
    });
  }

  setConfigurationTableLinkScan(): void {
    this.tableConfigurationsLinkScan = new ITableConfig({
      showPaginator: false,
      showColumnSelector: false,
      showForSelectionRow: false,
      isRowClickable: true,
      multiselect: false,
      viewSearch: false,
      resizableColumns: true,
      reorderableColumns: true,
      height: '40vh',
      tableStyle: { width: '100%', minWidth: '100%', maxWidth: '100%' },
    });
  }

  setModalConfiguration(): void {
    this.modalHeader = {
      title: this.translater.translate('iscan.infos.showPointsMeetingsLink'),
      iconTitle: 'bi bi-link-45deg',
      showNotification: false,
      showParameters: false,
      closable: true,
    };
    this.modalParams = {
      isDraggable: true,
      isResizable: true,
      isModal: true,
      style: { width: '60vw', minWidth: '60vw', maxWidth: '60vw' },
    };
  }

  setMenuAction(): void {
    switch (this.tabsArrayXLActiveIndex) {
      case 0:
        this.menu = getMenuCase1(this, this.translater);
        break;
      case 1:
        this.menu = getMenuCase2(this, this.translater);
        break;
      case 2:
        this.menu = [];
        break;
    }
  }

  uploadFile(event: Event): void {
    if ((event.target as HTMLInputElement).files[0].size > 270000000) {
      this.initButton();
      this.toastr.error(
        this.translater.translate('iscan.error.maxSize'),
        this.translater.translate('iscan.error.fileToLarge')
      );
      return;
    }
    const globalConfig: SessionStorage = this.getGlobalConfig();
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const toastRef = this.toastr.info('En cours de chargement', 'Chargement', {
        timeOut: 0,
        extendedTimeOut: 0,
        tapToDismiss: false,
      });
      const file: FileList = input.files;
      const dataToSend = {
        file: [],
        splitMode: 'qrcode',
        callback: globalConfig.apiGatewayBaseUrl + globalConfig.iScanCallbackToIdelibe,
      };
      Array.from(file).forEach((f) => {
        dataToSend.file.push(f);
      });
      this.iscanServices.upload(dataToSend).subscribe({
        next: (resp: UploadScan) => {
          const data: AddScanIDelibe = {
            lotGuid: resp[0].guid,
            filename: resp[0].name,
            uploadDate: new Date(),
            scanType: 'Manuel',
            pagesCount: resp[0].numPages,
          };
          this.ScanService.createScan(data).subscribe({
            next: () => {
              this.toastr.clear(toastRef.toastId);
              this.toastr.success(
                this.translater.translate('iscan.success.scanCreate'),
                this.translater.translate('iscan.success.success')
              );
              this.initButton();
              input.value = '';
              this.getItems('toTreat', 1);
            },
            error: (error) => {
              this.initButton();
              input.value = '';
              this.toastr.clear(toastRef.toastId);
              this.toastr.error(error.message, this.translater.translate('iscan.error.error'));
            },
          });
        },
        error: (error) => {
          this.initButton();
          input.value = '';
          this.toastr.clear(toastRef.toastId);
          this.toastr.error(error.message, this.translater.translate('iscan.error.error'));
        },
      });
    }
  }

  openFileSelector(): void {
    this.fileInput.nativeElement.click();
    this.buttons[0].disabled = true;
    this.buttons[0].loading = true;
  }

  initButton(): void {
    this.buttons[0].disabled = false;
    this.buttons[0].loading = false;
  }

  changeTab(event: SuperTabsXl): void {
    this.items = [];
    switch (event.id) {
      case 'toTreat':
        this.tabsArrayXLActiveIndex = 0;
        break;
      case 'treated':
        this.tabsArrayXLActiveIndex = 1;
        break;
      case 'history':
        this.tabsArrayXLActiveIndex = 2;
        break;
    }
    this.getItems(event.id, 1);
    this.setMenuAction();
  }

  getItems(tabs: string, pageNumber: number): void {
    const data = {
      pageNumber: pageNumber,
      PageSize: this.rows,
      StIds: tabs === 'toTreat' ? [1, 2] : tabs === 'treated' ? [3] : [1, 2, 3],
    };
    this.ScanService.getScanLots(data).subscribe({
      next: (res: ScanFromDelibePaginate) => {
        this.totalRecords = res.totalCount;
        this.rows = res.pageSize;
        this.first = res.pageNumber - 1;
        this.items = res.items;
        this.pageNumber = res.pageNumber;
        this.setConfigurationTable();
        this.uniqueUserIds = Array.from(new Set(this.items.map((item) => item.userId)));
      },
      error: () => {
        this.toastr.error(this.translater.translate('iscan.error.errorRetrievingScan'));
      },
    });
  }

  onLazyLoad(event: { first: number; rows: number }): void {
    this.rows = event.rows;
    this.pageNumber = event.first / event.rows + 1;
    switch (this.tabsArrayXLActiveIndex) {
      case 0:
        this.getItems('toTreat', this.pageNumber);
        break;
      case 1:
        this.getItems('treated', this.pageNumber);
        break;
      case 2:
        this.getItems('history', this.pageNumber);
        break;
    }
  }

  verifyStatus(event: ScanFromDelibe): Observable<number> {
    if (event.lastTransition.statutId === 1) {
      return this.iscanServices.getStatus(event.guid).pipe(
        tap((resp) => {
          if (resp.status === 'completed') {
            return this.updateStatutIdelibeScan(event);
          } else {
            const dateExpired = addDays(new Date(event.lastTransition.date), 1);
            if (dateExpired < new Date()) {
              this.toastr
                .warning(
                  'Merci de contacter le support pour débloquer la situation',
                  'Le délais de traitement est trop long',
                  { closeButton: true, progressBar: true }
                )
                .onTap.pipe(take(1))
                .subscribe(() => {
                  this.router.navigate(['/private/assistance']);
                });
            } else {
              this.toastr.warning(
                this.translater.translate('iscan.infos.scanBeingProcessed'),
                this.translater.translate('iscan.warning.warning')
              );
            }
            return -1;
          }
        }),
        catchError((error) => {
          this.toastr.error(error.message, this.translater.translate('error.occurred'));
          return of(-1);
        })
      );
    } else {
      return of(event.lastTransition.statutId);
    }
  }

  updateStatutIdelibeScan(event: ScanFromDelibe): void {
    const data = {
      lotGuids: [event.guid],
      status: 'Processed',
    };
    this.ScanService.updateStatusScan(data).subscribe({
      next: () => {
        this.toastr.success(
          this.translater.translate('iscan.infos.statusUpdated'),
          this.translater.translate('iscan.success.success')
        );
        this.getItems('toTreat', this.pageNumber);
        return 2;
      },
      error: (error) => {
        this.toastr.error(error.message, this.translater.translate('iscan.error.errorRetrievingStatus'));
        return -1;
      },
    });
  }

  modifyScan(event: ITableItem): void {
    if (this.tabsArrayXLActiveIndex === 0) {
      this.verifyStatus(event as ScanFromDelibe).subscribe({
        next: (status) => {
          if (status === 2) {
            this.router.navigate(['/private/iscan/detail/' + event.guid]);
          }
        },
        error: (error) => {
          this.toastr.error(error.message, this.translater.translate('iscan.error.error'));
        },
      });
    } else if (this.tabsArrayXLActiveIndex === 1) {
      this.openDialogDocumentLink = true;
      this.getItemsDocumentLink(event as ScanFromDelibe);
      return;
    }
  }

  showDetails(scan: ITableItem): void {
    if (scan.pointId) {
      window.open('private/points/detail/' + scan.pointId, '_blank');
    } else if (scan.seanceId) {
      window.open('private/meetings/details/' + scan.seanceId, '_blank');
    }
  }

  verifyStatusDeleteScan(event: ScanFromDelibe): void {
    this.verifyStatus(event).subscribe({
      next: (status) => {
        if (status === 2) {
          this.confirmDeleteScan(event);
        }
      },
      error: (error) => {
        this.toastr.error(error.message, this.translater.translate('iscan.error.error'));
      },
    });
  }

  confirmDeleteScan(event: ScanFromDelibe): void {
    this.confirmationService.confirm({
      message:
        this.translater.translate('iscan.infos.wantDeleteScan') +
        ' ' +
        this.translater.translate('iscan.infos.youCantRecover'),
      accept: () => this.deleteScan(event),
    });
  }

  deleteScan(event: ScanFromDelibe): void {
    this.spinner.show();
    this.ScanService.deleteScan([event.guid]).subscribe({
      next: () => {
        this.toastr.success(
          this.translater.translate('iscan.global.theScan') +
            event.filename +
            ' ' +
            this.translater.translate('iscan.success.delete'),
          this.translater.translate('iscan.success.success')
        );
        this.getItems('toTreat', this.pageNumber);
        this.spinner.hide();
      },
      error: () => {
        this.toastr.error(this.translater.translate('iscan.error.errorSuppression'));
        this.spinner.hide();
      },
    });
  }

  downloadDocument(event: ScanFromDelibe): void {
    this.iscanServices.downloadFile(event.guid).subscribe({
      next: (resp) => {
        const downloadURL = URL.createObjectURL(resp);
        saveAs(downloadURL, event.filename);
        this.toastr.success(this.translater.translate('iscan.success.download'));
      },
      error: () => {
        this.toastr.error(this.translater.translate('iscan.error.download'));
      },
    });
  }

  getItemsDocumentLink(event: ScanFromDelibe): void {
    this.itemsDocumentLink = event.splits as any as ITableItem[];
  }
}
